import React, { useContext, useMemo } from 'react'
import i18n from 'simple-react-i18n'
import { shallowEqual, useSelector } from 'react-redux'
import { ModuleHabsContext, ModuleHabsDispatchContext } from './AdminModulesApp'
import SimpleSelectionTable from 'components/datatable/SimpleSelectionTable'
import FormFilterUsers from '../user/components/FormFilterUsers'
import { normalizeString } from 'utils/StringUtil'
import { nbPerPageLabelShort } from 'referencial/constants/ReferencialConstants'
import { keyBy } from 'lodash'

const UserAssignmentPanel = () => {
    const {
        users,
        contacts,
    } = useSelector(store => ({
        users: store.UserReducer.users,
        contacts: store.ContactReducer.contacts,
    }), shallowEqual)

    const moduleHabs = useContext(ModuleHabsContext)
    const moduleHabsDispatch = useContext(ModuleHabsDispatchContext)

    const usersData = useMemo(() => users.filter(u => !u.isApplicative).map(u => ({
        ...u,
        id: u.login,
        labelSearch: [u.login].map(l => normalizeString(l)).join('#'),
    })), [users])
    const selectedUsers = moduleHabs.selectedUsersModule.map(({ login }) => login)

    const onChange = listUsers => {
        const indexedList = keyBy(moduleHabs.selectedUsersModule, 'login')
        moduleHabsDispatch({ type: 'selectedUsersModule', payload: listUsers.map(u => indexedList[u] ?? { login: u }) })
    }

    return (
        <SimpleSelectionTable
            onChange={onChange}

            listData={usersData}
            selectedList={selectedUsers}

            listHeaders={['login']}
            listTitle={i18n.nonSelectedUsers}
            selectedListTitle={i18n.selectedUsers}

            filterField={({ setFilter }) => <FormFilterUsers onValidate={setFilter} noCard noApplicativeUsers />}
            filterFunction={(list, { searchValue, contributors, cities, isAdmin, metadata, labo, consultant }) => {
                const usersFilteredBySearchValue = searchValue ? list.filter(u => u.labelSearch.includes(normalizeString(searchValue))) : list
                const usersFilteredByOrganization = contributors?.length > 0 ? usersFilteredBySearchValue.filter(user => contributors.includes(user.contributorCode)) : usersFilteredBySearchValue
                const usersFilteredByCity = cities?.length > 0 ? usersFilteredByOrganization.filter(user => {
                    const contact = find(contacts, (o) => {
                        return o.code == user.contactCode
                    })
                    return (contact && cities.includes(contact.cityCode)) && user
                }) : usersFilteredByOrganization

                const usersFilteredByAdmin = isAdmin ? usersFilteredByCity.filter(user => user.admin === '1') : usersFilteredByCity
                const usersFilteredByAdministrator = metadata ? usersFilteredByAdmin.filter(user => user.metadata === '1') : usersFilteredByAdmin
                const usersFilteredByTechnicien = labo ? usersFilteredByAdministrator.filter(user => user.labo === '1') : usersFilteredByAdministrator
                return consultant ? usersFilteredByTechnicien.filter(user => user.consultant === '1') : usersFilteredByTechnicien
            }}
            nbPerPage={nbPerPageLabelShort}
        />
    )
}

export default UserAssignmentPanel